import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { translations } from "@/i18n";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("boost_lang") || "de");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const t = useCallback((key) => translations[lang][key] ?? key, [lang]);

  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem("boost_lang", l);
  };

  useEffect(() => {
    const token = sessionStorage.getItem("boost_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => sessionStorage.removeItem("boost_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = (token, userObj) => {
    sessionStorage.setItem("boost_token", token);
    setUser(userObj);
  };

  const logout = () => {
    sessionStorage.removeItem("boost_token");
    setUser(null);
  };

  return (
    <AppContext.Provider value={{ lang, changeLang, t, user, login, logout, loading }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
